import { GetDateUSSemValue } from "src/shared/Utils/FormatDateBR";

import {
  ICreateContrato,
  IValuesFilterBordero,
  IValuesFilterContrato,
  ICreateBorderoParcela,
} from "../ContratosTypes";
import moment from "moment";

export const valueDefaultInputContratos: ICreateContrato = {
  assinatura_data: `${GetDateUSSemValue()}`,
  cod_proposta: "",
  tipo_contrato: "PF",
  cpf_cnpj: "",

  titular_pf: "",
  rg_pf: "",
  mae_pf: "",
  estado_civil_pf: "",
  data_nacimento_pf: "",
  genero_pf: "",
  responsavel_pf: "",
  cpf_responsavel_pf: "",
  data_nascimento_responsavel_pf: "",

  razao_social_pj: "",
  contato_responsavel_pj: "",
  cargo_pj: "",

  email: "",
  telefone_1: "",
  telefone_2: "",
  cep: "",
  endereco: "",
  endereco_numero: "",
  complemento: "",
  bairro: "",
  cidade: "",
  uf: "",
  emissao_data: `${GetDateUSSemValue()}`,
  vencimento_data_proposta: `${moment().add(1, "year").format("YYYY-MM-DD")}`,

  vencimento_data: `${GetDateUSSemValue()}`,

  vencimento_data_2: `${moment().add(1, "month").format("YYYY-MM-DD")}`,
  vigencia_data: `${GetDateUSSemValue()}`,
  mensalidade_value: "0.00",

  is_producer_receveid_installment: "NAO",
  is_collect_fee_producer: "NAO",
  font_lead: "NONE",

  taxa_value: "0.00",
  vidas: "1",

  iof_porc: "0.00",

  dependentes: [],
  observacoes: "",
};

export const valueDefaultInputBorderoParcelas: ICreateBorderoParcela = {
  id: "",
  valor_recebido: "",
  data_recebimento: `${GetDateUSSemValue()}`,
  data_previsao: "",
  observacao: "",
  total_com_desconto: "",
  desconto_parcela: "",
  tipo_desconto_parcela: "VALOR",
  contratos_vidas: 1,
  valor_comissao_corretor: "",
  valor_comissao_corretora: "",
  valor_comissao_gerente: "",
  valor_comissao_supervisor: "",
  porcentagem_comissao_corretora: "",
  porcentagem_comissao_corretor: "",
  porcentagem_comissao_gerente: "",
  porcentagem_comissao_supervisor: "",
  id_corretor: "",
  id_supervisor: "",
  id_gerente: "",
};

export const valuesDefaultFilterContrato: IValuesFilterContrato = {
  endDateEmission: "",
  startDateEmission: "",
  cod_proposta: "",
  startDateSignature: "",
  endDateSignature: "",
  startEffectiveDate: "",
  endEffectiveDate: "",
  nameOrRazao: "",
  startVencimentoDate: "",
  endVencimentoDate: "",

  cpfCnpj: "",

  status: "ALL",
  isDeleted: "FALSE",
  isVitalicioCorretora: "ALL",
  isVitalicioCorretor: "ALL",
  isVitalicioSupervisor: "ALL",
  isVitalicioGerente: "ALL",
};

export const valuesDefaultFilterBordero: IValuesFilterBordero = {
  cod_proposta: "",
  startDateSignature: "",
  endDateSignature: "",
  endDateReceipt: "",
  endDueDate: "",
  installmentNumber: "",
  startDateReceipt: "",
  startDueDate: "",
  endDateEmission: "",
  startDateEmission: "",

  installmentReceipt: "ALL",
  isInstallmentManager: "ALL",
  isInstallmentBroker: "ALL",
  isInstallmentSupervisor: "ALL",

  isVitalicioCorretora: "ALL",
  isVitalicioCorretor: "ALL",
  isVitalicioSupervisor: "ALL",
  isVitalicioGerente: "ALL",
  isDeleted: "FALSE",

  installmentNumberOperator: "ALL",

  nameOrRazao: "",
  cpfCnpj: "",
};

